import type { DatadogDynamicConfig } from '@dn/libs/ui/dn-common';
import { DatadogEnvironment } from '@dn/libs/ui/dn-common';
import type { Environment } from '../../../environments/environment.interface';

export enum DatadogEnvironmentMapping {
    dev = DatadogEnvironment.DEV,
    staging = DatadogEnvironment.STAGING,
    production = DatadogEnvironment.PRODUCTION,
}

export function createDatadogConfig(appConfig: Environment): DatadogDynamicConfig {
  return {
    applicationId: 'fdac48bd-2ce5-48f0-8279-029ad45e0da4',
    clientToken: 'pub96c5fe43ef97653e699a5c1772dc361d',
    service: 'datanyze-website',
    env: DatadogEnvironmentMapping[appConfig.name as keyof typeof DatadogEnvironmentMapping],
  };
}

// For backward compatibility, we'll need to inject this in components that use it
export const DatadogConfig: DatadogDynamicConfig = {
  applicationId: 'fdac48bd-2ce5-48f0-8279-029ad45e0da4',
  clientToken: 'pub96c5fe43ef97653e699a5c1772dc361d',
  service: 'datanyze-website',
  env: DatadogEnvironment.DEV, // Default fallback
};
